import { render, staticRenderFns } from "./AttachmentsGallery.vue?vue&type=template&id=0a950c4b&scoped=true&"
import script from "./AttachmentsGallery.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsGallery.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsGallery.vue?vue&type=style&index=0&id=0a950c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a950c4b",
  null
  
)

export default component.exports